import { CapitalCallsInboxScreen } from "@civala/investor-nexus-pitch"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/capital-calls")({
  component: CapitalCallsInboxScreen,
})
